import { PageRequest } from "@shared/zod/schemas/requests/page"
import { InboxItemPageResponse } from "@shared/zod/schemas/responses/inbox"

import { axiosAuth } from "./generic/AxiosInterceptor/AxiosInterceptor"

export const findAll = async (query?: PageRequest): Promise<InboxItemPageResponse> => {
  const resp = await axiosAuth({
    url: "/inbox",
    method: "get",
    params: query,
  })
  return resp.data
}
